// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__RKHMP","v3":"style_v3__3Aypy"};